var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconGettingStartedLearnMoreBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 90,
    height: 90,
    viewBox: "0 0 90 90",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_63_854)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M45 90C69.8528 90 90 69.8528 90 45C90 20.1471 69.8528 0 45 0C20.1471 0 0 20.1471 0 45C0 69.8528 20.1471 90 45 90Z",
    fill: "#DEF6FC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.315 35.9367C37.315 34.373 38.015 32.8734 39.261 31.7677C40.507 30.662 42.1969 30.0408 43.959 30.0408H45.8573C47.6194 30.0408 49.3093 30.662 50.5553 31.7677C51.8013 32.8734 52.5013 34.373 52.5013 35.9367C52.5712 37.2127 52.2388 38.4776 51.554 39.541C50.8693 40.6044 49.8693 41.4086 48.7047 41.8326C47.5402 42.3978 46.5402 43.4702 45.8555 44.888C45.1707 46.3058 44.8383 47.9924 44.9082 49.6937",
    stroke: "#0C6CDE",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.9081 57.5549V57.5745",
    stroke: "#0C6CDE",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_63_854"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 90,
    height: 90,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconGettingStartedLearnMoreBlue);
export default __webpack_public_path__ + "static/media/Icon_GettingStarted_LearnMore_Blue.30ce15a4db86e7eeae02125b83efb36a.svg";
export { ForwardRef as ReactComponent };